/* eslint-disable */
import logger from '@usb-ui-tools/logger'
import {
  defaultParams,
  initConfig,
  infoConfig,
  errorDefaultConfig,
  webViewErrorConfig,
  webViewInfoConfig,
  eventSourceDefaultParams,
  defaultEventAttributes,
  eventSourceDefaultParamsForOnboarding,
  getBusinessCapability,
  getDeeplinkSource
} from '../logger/loggerConfig'

const getSessionStorageValue = (name) => {
  return typeof window !== 'undefined'
    ? window.sessionStorage.getItem(name)
    : null
}

const stackError = (stack) => {
  return stack ? stack.replace(/\s{2,}/g, '') : stack
}

const currentSession = () =>
  typeof window !== 'undefined'
    ? JSON.parse(getSessionStorageValue('currentSession'))
    : null
// initialize logger
const initLogger = (config = initConfig) => {
  logger.init({ currentSession, ...config })
}

// information Logger
const infoLogger = (config) => {
  let configuration = {}
  console.log(infoConfig, 'infoConfig.eventAttributes')
  if (config) {
    // eslint-disable-next-line compat/compat
    configuration = {
      ...config,
      eventAttributes: Object.assign(
        infoConfig.eventAttributes,
        config.eventAttributes || {}
      )
    }
  } else {
    configuration = infoConfig
  }
  logger.info(configuration)
}

// error logger
const errorLogger = ({
  exceptionMsg,
  stack,
  severity = ['HIGH'],
  exceptionCode,
  eventSource,
  eventAttributes = {},
  ...rest
}) => {
  logger.error({
    ...errorDefaultConfig,
    eventSource: {
      ...eventSourceDefaultParams,
      ...eventSource
    },

    exception: {
      severity: [...severity],
      exceptionCode,
      exceptionMsg: `${exceptionMsg || ''}`,
      dumpAnalysis: stackError(stack)
    },

    eventAttributes: {
      ...defaultEventAttributes,
      qmSession:
        typeof window !== 'undefined' &&
        window.sessionStorage.getItem('qmSession'),
      ...eventAttributes
    },

    ...rest
  })
}

const webViewLogger = ({ level, error, eventSource, exceptionMsg }) => {
  let configuration = {}

  if (level === 'info') {
    configuration = webViewInfoConfig({ eventSource })

    logger.info({
      ...configuration
    })
  } else if (level === 'error') {
    configuration = webViewErrorConfig({
      eventSource,
      errorStack: stackError(error.stack ? error.stack : error),
      exceptionMsg
    })

    logger.error({
      ...configuration
    })
  }
}

const APIInfoLogger = (operationName, apiStatusCode) => {
  logger.info({
    level: 'info',
    eventSource: {
      ...eventSourceDefaultParams,
      component: 'Payee Management - Graphql_API',
      subComponent: 'Payee Management - ApolloClientInstance',
      stepName: operationName || 'API_REQUEST_SUCESSFUL'
    },
    eventAttributes: {
      ...defaultEventAttributes,
      apiOperationName: operationName || 'Not Defined',
      apiStatusCode,
      type: 'API'
    },
    ...defaultParams
  })
}

/* Kibana logs for onboarding team */
const OnboardingSuccessInfoLogger = (featureCode, successMessage) => {
  logger.info({
    eventSource: {
      ...eventSourceDefaultParamsForOnboarding,
      stepName: featureCode
    },
    eventStatus: 'SUCCESS',
    exception: {
      message: successMessage
    },
    eventAttributes: {
      message: `${featureCode} > ${successMessage}`,
      qmSession:
        typeof window !== 'undefined' &&
        window.sessionStorage.getItem('qmSession')
    }
  })
}

const OnboardingErrorInfoLogger = (featureCode, errorMessage) => {
  logger.info({
    eventSource: {
      ...eventSourceDefaultParamsForOnboarding,
      stepName: featureCode
    },
    eventStatus: 'ERROR',
    exception: {
      message: errorMessage
    },
    eventAttributes: {
      message: `${featureCode} > ${errorMessage}`,
      qmSession:
        typeof window !== 'undefined' &&
        window.sessionStorage.getItem('qmSession')
    }
  })
}

const APIErrorLogger = (
  operationName,
  variables,
  message,
  apiStatusCode,
  response,
  headers
) => {
  logger.error({
    error: message,
    eventSource: {
      ...eventSourceDefaultParams,
      component: 'Payee Management - Graphql_API',
      subComponent: 'Payee Management - ApolloClientInstance',
      stepName: operationName || 'API_REQUEST_FAILED'
    },
    eventAttributes: {
      ...defaultEventAttributes,
      apiOperationName: operationName || 'Not Defined',
      apiRequestObject: variables || 'Not Defined',
      apiResponseObject: message || 'Not Defined',
      apiStatusCode,
      type: 'API',
      error: message || 'Not Defined'
    },
    eventStatus: 'ERROR',
    exception: {
      severity: ['HIGH'],
      exceptionMsg: 'API_REQUEST_FAILED',
      dumpAnalysis: message
    },
    ...defaultParams
  })
}

if (typeof window !== 'undefined') {
  window.loggerUtility = webViewLogger
}

export {
  getSessionStorageValue,
  stackError,
  initConfig,
  infoConfig,
  initLogger,
  infoLogger,
  errorLogger,
  webViewLogger,
  APIInfoLogger,
  APIErrorLogger,
  OnboardingSuccessInfoLogger,
  OnboardingErrorInfoLogger
  // isSensitiveContent,
  // getMaskedRequest  // Handle Masking later based on graphQL request and response
}
